import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import "swiper/swiper-bundle.css";

export default class NewArrivalsSwiper {
    constructor() {
        const wrapper = document.querySelectorAll('.homepage-new-arrivals__widget-wrapper');

        if(!wrapper.length) {
            return;
        }

        wrapper.forEach((wrap) => {
            const NewArrivalSwiper = new Swiper('.homepage-new-arrivals__swiper', {
                navigation: {
                    nextEl: ".swiper-button-next-arrivals",
                    prevEl: ".swiper-button-prev-arrivals"
                },

                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
            
                slidesPerView: 4,
                spaceBetween: 40,
                loop: true,
            
                modules: [ Navigation, Pagination ],
            
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                    
                    769: {
                        slidesPerView: 4,
                        spaceBetween: 40,
                    }
                }
            });
        });
    }
}